import style from "./Select.module.css"
import {useEffect, useState} from "react";
import React from "react";
import $ from "jquery"

function Select(props) {
    const [options, setOptions] = useState([])
    const [classNameSelect] = useState(
        props.autocomplete ? style.struttura.concat(" selectpicker") : style.struttura
    )

    useEffect(() => {
        if (props && props.options) {
            const newOptions = props.options.map((option, index) => (
                <option
                    key={option.codice || option.codiceSportello || index}
                    value={option.codice || option.codiceSportello || option.descrizione}
                >
                    {option.descrizione}
                </option>
            ));
            setOptions(newOptions);
        }
    }, [props.options]);

    useEffect(() => {
        if (props.autocomplete) {
            $(document).ready(function () {
                $('#' + props.id).selectpicker('refresh')
            });
        }
    }, [props.functionMap, props.options])

    useEffect(() => {
        if (props.disabled && props.autocomplete) {
            $(document).ready(function () {
                $('#' + props.id).selectpicker('disabled')
                $('.selectpicker').selectpicker('refresh')
            });
        } else if (!props.disabled && props.autocomplete) {
            $(document).ready(function () {
                $('#' + props.id).selectpicker('enable')
                $('.selectpicker').selectpicker('refresh')
            });
        }
    }, [props.disabled])

    const functionMapWithKeys = props.functionMap
        ? React.Children.map(props.functionMap, (el, idx) => {
            if (!React.isValidElement(el)) return el;
            return React.cloneElement(el, {
                key: el.key ?? el.props?.value ?? idx
            });
        })
        : null;

    return (
        <div
            className={props.autocomplete ? "bootstrap-select-wrapper" : ""}
            style={{opacity: props.disabled && props.autocomplete ? "0.7" : ""}}
        >
            <select
                multiple={props.multiple}
                className={classNameSelect}
                id={props.id}
                value={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
                style={props.style}
                data-live-search={props.autocomplete ? "true" : ""}
                data-live-search-placeholder={props.autocomplete ? "Cerca opzioni" : ""}
            >
                {props.default ? <></> : (
                    <option key="default-placeholder" value="" hidden>
                        {props.placeholder ? props.placeholder : "Scegli un opzione..."}
                    </option>
                )}
                {props.multiple ? functionMapWithKeys : options}
            </select>
        </div>
    )
}

export default Select